$(document).ready(function(){
    let store_code = Cookies.get("_geo_store_code");
    $.get(`https://beans.secretlab.co/index.php/api/retrieve_faq/nx${(store_code === 'US' ? '' : `_${store_code}`)}`, function (data) {
        $.each(data.faq, function (category, sets) {
            $.each(sets, function (key, row) {
                if (["US", "AU", "SG"].includes(store_code)) {
                  if (['faq6', 'faq53', 'faq55', 'faq59', 'faq60'].indexOf(key) > -1) {
                    $('#'+category+'_content').append('<div class="faq-question-wrapper" id="'+key+'_wrapper"><div class="row faq-question" data-id="'+key+'">'+
                                        '<div class="col">Where can I purchase a NeueChair?</div><div class="col-auto"><span><i class="fas fa-angle-right"></i></span></div>'+
                                    '</div><div class="faq-answer" style="display:none">We have fully sold out Neue chairs in ' + store_code + ' and will not be restocking on our website. Thank you for your support!</div></div>');
                  } else if (['faq86', 'faq15'].indexOf(key) > -1) {
                    $('#'+category+'_content').append('<div class="faq-question-wrapper" id="'+key+'_wrapper"><div class="row faq-question" data-id="'+key+'">'+
                                        '<div class="col">'+row.the_question+'</div><div class="col-auto"><span><i class="fas fa-angle-right"></i></span></div>'+
                                    '</div><div class="faq-answer" style="display:none"><ul><li>For any warranty related issues, email an image or video of the relevant affected area to <a title="info@neuechair.com" href="mailto:info@neuechair.com" target="_blank" rel="noopener">info@neuechair.com</a> within 14 days of delivery date and our support team will assist you as quickly as possible.</li><li>NeueChair reserves the final right in determining if a benefit under the warranty can be claimed.</li></ul><br/>Read our full warranty statement <a href="https://neuechair.com/pages/warranty-terms" target="_blank" rel="noopener">here</a>.</div></div>');
                  } else if (['faq48', 'faq92', 'faq50', 'faq51', 'faq52', 'faq1', 'faq2', 'faq3', 'faq5', 'faq7', 'faq56', 'faq87', 'faq16'].indexOf(key) === -1) {
                    $('#'+category+'_content').append('<div class="faq-question-wrapper" id="'+key+'_wrapper"><div class="row faq-question" data-id="'+key+'">'+
                                        '<div class="col">'+row.the_question+'</div><div class="col-auto"><span><i class="fas fa-angle-right"></i></span></div>'+
                                    '</div><div class="faq-answer" style="display:none">'+row.the_answer+'</div></div>');
                    if ('1' === row.is_popular_question) {
                        $('#popular_content').append('<div class="faq-question-wrapper" id="'+key+'_wrapper"><div class="row faq-question" data-id="'+key+'">'+
                                        '<div class="col" id='+key+'>'+row.the_question+'</div><div class="col-auto"><span><i class="fas fa-angle-right"></i></span></div>'+
                                    '</div><div class="faq-answer" style="display:none">'+row.the_answer+'</div></div>');
                    }
                  }
                } else {
                  $('#'+category+'_content').append('<div class="faq-question-wrapper" id="'+key+'_wrapper"><div class="row faq-question" data-id="'+key+'">'+
                                    '<div class="col">'+row.the_question+'</div><div class="col-auto"><span><i class="fas fa-angle-right"></i></span></div>'+
                                '</div><div class="faq-answer" style="display:none">'+row.the_answer+'</div></div>');
                  if ('1' === row.is_popular_question) {
                      $('#popular_content').append('<div class="faq-question-wrapper" id="'+key+'_wrapper"><div class="row faq-question" data-id="'+key+'">'+
                                      '<div class="col" id='+key+'>'+row.the_question+'</div><div class="col-auto"><span><i class="fas fa-angle-right"></i></span></div>'+
                                  '</div><div class="faq-answer" style="display:none">'+row.the_answer+'</div></div>');
                  }
                }
            });
        });
        $('.replace_email').each(function () {
            $(this).html(store_email).attr('href', 'mailto:'+store_email);
        });
    }, 'json');
    // ACCORDION
    $('body').on('click', '.faq-question', function() {
        if ( $(this).hasClass('active') ) {
            $(this).parent().children('.faq-answer').stop().slideUp();
            $(this).removeClass('active');
            $(this).find('span').removeClass('rotate90');
        } else {
            $('.faq-answer').stop().slideUp();
            $('.faq-question').removeClass('active');
            $('.faq-question').find('span').removeClass('rotate90');
            $(this).parent().children('.faq-answer').stop().slideDown();
            $(this).addClass('active');
            $(this).find('span').addClass('rotate90');
        }
    });
    // SEARCH
    $('#store_code').val('NX');
    $('#faq-search').keyup(function () {
        var query = $(this).val().toLowerCase();
        track_query_setup(query);
        search_faq(query);
    });
    // FUNCTIONS
    check_for_track();
    function check_for_track() {
        setTimeout(function () {
            var ts = parseInt((new Date().getTime())/1000);
            $('#this_time').val(ts);
            var send_ts = $('#sending_timestamp').val();
            if ("" !== send_ts && ts >= send_ts) {
                track_query();
            }
            check_for_track();
        }, 1000);
    }
    function track_query_setup(query) {
        var seconds_delay = 5;
        $('#keyword_to_use').val(query);
        var ts = parseInt((new Date().getTime())/1000)+seconds_delay;
        $('#sending_timestamp').val(ts);
    }
    function track_query() {
        $('#sending_timestamp').val('');
        var query = $('#keyword_to_use').val();
        if ('' !== query) {
            $.post('https://beans.secretlab.co/index.php/api/track_faq_query', {query_term: query, store: $('#store_code').val()}, function (data) {
                console.log('mesage: '+data.message);
            }, 'json');
        }
    }
    function search_faq(query) {
        if ("" !== query) {
            $('#popular, .page-redirect-wrapper').hide();
        } else {
            $('#popular, .page-redirect-wrapper').show();
        }
        $('#faq-all, #main, #orders, #shipping, #delivery, #warranty, #assembly, .faq-question-wrapper').filter(function() {
            $(this).toggle($(this).text().toLowerCase().indexOf(query) > -1)
        });
        if ( $('#faq-all').is(':hidden') ) { $('#faq_nothing').show(); } else { $('#faq_nothing').hide(); }
    }
});